<template>
  <div class="matcher-plate">
    <div class="matcher-plate__header">
      <div class="matcher-plate__image">
        <b-img
          v-if="stream.attributes.image == ''"
          v-bind="{ blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' }"
          rounded="circle"
          alt="Circle image"
        ></b-img>
        <img
          v-if="stream.attributes.image"
          :src="stream.attributes.image"
          :alt="stream.attributes.name"
        />
      </div>

      <div class="matcher-plate__data">
        <div class="d-flex">
          <h2 class="matcher-plate__title">{{ stream.attributes.title }}</h2>
        </div>
        <p class="stream-order-text">{{ stream.attributes.description }}</p>
      </div>
    </div>
    <div class="tw-p-4">
      <CampaignProgress
        :campaignAttrs="{
          currency: '$',
          campaign_stats: { total: stream.attributes?.total || 0 },
          rounds: [{ goal: stream.attributes.goal }],
        }"
      />
      <p class="stream-order-text">
        {{ $t("edit_campaign.donation_stream_donors", "Donors") }}:
        {{ stream.attributes?.donors_count || 0 }}
      </p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CampaignProgress from "../../campaignProgress.vue";

export default Vue.extend({
  props: ["stream", "loading"],

  components: {
    CampaignProgress,
  },

  data() {
    return {
      loadingInternal: false,
    };
  },
});
</script>

<style lang="scss" scoped>
.level-plate {
  &__color {
    margin-left: 20px;
    width: 3rem;
    height: 20px;
  }
}
.stream-order-wrapper {
  padding-top: 13px;
}
.stream-order-text,
.stream-order-text-title {
  font-size: 1rem;
  line-height: 1;
  color: #414359;
}
.stream-order-text-title {
  margin-left: 60px;
  margin-right: 5px;
}

.no-padding-left {
  padding-left: 0;
}
</style>
